module.exports = __webpack_public_path__ + "static/media/arrow.68bdbbbe.svg";